<template>
  <div class="modal" v-if="seen">
    <div class="deletefile">
      <span @click="closebox" class="closefile">
        <img src="@/assets/Close Button.svg" />
      </span>
      <div class="header d-flex justify-content-center align-items-center mt-2">
        <h6><strong><template v-if="is_folder">Folder</template><template else>File</template> created
            successfully...</strong></h6>
      </div>
      <div class="cgn text-center my-2">
        <span>Do you want to navigate to <template v-if="is_folder">Folder</template><template else>File</template>
          location</span>
      </div>
      <div class="save">
        <span class="btn-move-to-trash" @click="browse">
          Browse to <template v-if="is_folder">folder</template><template else>file</template> location
        </span>
        <span class="btn-close" @click="closebox">
          Cancel
        </span>
      </div>
    </div>
  </div>
</template>
<style scoped>
.header {
  padding: .5em 0 0 0 !important;
}

.header h3 {
  font-size: 22px;
  font-weight: bold;
}

.save {
  margin-top: 0 !important;
}

.cgn {
  display: flex;
  flex-direction: column;
}

.cgn span {
  margin-bottom: .4em;
  font-size: 14px;
}

.deletefile {
  padding: 2em !important;
}

.modal div.deletefile {
  width: 420px !important;
}

.modal div.deletefile div {
  width: 100% !important;
  margin-left: 0 !important;
}

.save {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.save span {
  flex: 1 !important;
}

.save .btn-move-to-trash {
  background: #3F96D1 !important;
  color: #fff !important;
  font-size: 13px !important;
}

.save .btn-close {
  background: #D9ECFA !important;
  border: 1px solid #D9ECFA !important;
  font-size: 13px !important;
  color: #000 !important;
}

.save .btn-delete {
  background: transparent !important;
  border: 1px solid #FC6D6C !important;
  font-size: 13px !important;
  color: #FC6D6C !important;
}

.modal div.deletefile .closefile {
  top: 13px !important;
  right: 13px !important;
}
</style>

<script>
import cookies from '@/services/cookies'
import { mapMutations } from 'vuex'
export default {
  data() {
    return {
      name: '',
      seen: false,
      loader: false,
      error: false,
      id: null,
      found: false,
      is_folder: false,
      db: ''
    }
  },
  methods: {
    ...mapMutations([
      'SET_DB',
      'SET_DIRECTORY_CHILDREN',
      'SET_STORED_DIRECTORY_CHILDREN',
      'SET_CURRENT_DIRECTORY',
      'SET_PATH',
      'SORT_DIRECTORY_CHILDREN'
    ]),
    logincall() {
      this.$parent.logincall()
    },
    str_text(str) {
      return str.length > 60 ? str.substr(0, 60) + '...' : str
    },
    load(id, name, db, is_folder) {
      this.seen = true
      this.loader = false
      this.id = id
      this.is_folder = is_folder
      this.name = name
      this.db = db
    },
    browse() {
      let that = this

      let data = {
        db: this.db,
        token: cookies.getCookie('token'),
        current_directory_id: this.id
      }

      this.$socket.emit('browse', data, function (data) {
        if (data.data === true) {
          localStorage.setItem('current_directory_id', that.id)
          localStorage.setItem('current_directory', that.name)
          localStorage.setItem('db', that.db)
          that.seen = false
          that.SET_DB(that.db)
          that.SET_DIRECTORY_CHILDREN(data.directory_children)
          that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children)
          that.SET_CURRENT_DIRECTORY(that.name)
          that.SET_PATH(data.dir_path)
          that.SORT_DIRECTORY_CHILDREN()
        }

        if (data.data === false) {
          that.logincall()
          that.$router.push('/login')
        }
      })
    },
    closebox() {
      this.seen = false
    }
  }
}
</script>
